"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const material_1 = require("@mui/material");
const useTriviaStyle = () => {
    const theme = (0, material_1.useTheme)();
    const triviaStyles = {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '16px',
        position: 'relative',
        width: '100%',
        background: theme.palette.secondary.main,
        borderRadius: '8px',
    };
    const textGroup = {
        background: 'transparent',
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
    };
    const iconStyles = {
        color: theme.palette.primary.main,
    };
    const textStyles = Object.assign(Object.assign({}, theme.qlub.typography.caption_overline), { fontFamily: 'inherit', color: theme.palette.primary.main });
    const closeButtonStyles = {
        color: theme.palette.primary.main,
        padding: '0',
    };
    return {
        triviaStyles,
        iconStyles,
        textGroup,
        textStyles,
        closeButtonStyles,
    };
};
exports.default = useTriviaStyle;
